import React from 'react'
import EmptyHeader from 'containers/EmptyHeader'
import styled from 'styled-components'
import {
  Button,
  IsEmbedded,
  NotEmbedded,
  ErrorMessage,
} from '@sketch/components'
import { EmbeddedErrorPage } from 'modules/shares/components/EmbeddedErrorPage'
import * as Sentry from '@sentry/browser'
import { ApolloError } from 'apollo-client'
import { CenterContent } from 'containers/CenterContent'

const StyledErrorMessage = styled(ErrorMessage.Generic)`
  flex: 1 0 auto;
  max-width: 500px;
  margin: auto;
`

interface GenericErrorViewProps {
  error?: ApolloError | string
  errorTitle?: string
  onClick?(): void
}

const GenericErrorView = ({
  error,
  errorTitle,
  onClick,
}: GenericErrorViewProps) => {
  if (typeof error === 'string') {
    Sentry.captureException(error)
  } else if (error?.graphQLErrors) {
    const versionForbiddenError = error.graphQLErrors.every(e =>
      [
        'USER_CANT_VIEW_OLD_SHARE_VERSIONS',
        'USER_CANT_VIEW_VERSION_HISTORY',
        'USER_CANT_VIEW_SHARE_VERSION',
      ].includes(e.extensions?.reason)
    )

    const authError = error.graphQLErrors.every(e =>
      [
        'ACCESS_TOKEN_EXPIRED',
        'INVALID_ACCESS_TOKEN',
        'USER_NOT_LOGGED_IN',
        'TOKEN_EXPIRED',
        'NO_TOKEN',
      ].includes(e.extensions?.reason)
    )

    if (!versionForbiddenError && !authError) {
      Sentry.captureException(error)
    }
  }

  const onClickHandler = onClick || (() => window.location.reload())

  return (
    <>
      <NotEmbedded>
        <CenterContent>
          <EmptyHeader />
          <StyledErrorMessage
            title={errorTitle || 'There was an error loading this information'}
            extra={
              <Button variant="primary" onClick={onClickHandler}>
                Refresh the page to try again
              </Button>
            }
          />
        </CenterContent>
      </NotEmbedded>
      <IsEmbedded>
        <EmbeddedErrorPage for="unknown" />
      </IsEmbedded>
    </>
  )
}

export default GenericErrorView
